var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web User",
    clipPath: "url(#clip0_5833_30800)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4935 19.2812C21.9121 19.2812 25.2325 12.6244 25.2325 8.30795C25.2325 3.73143 21.77 0 17.4935 0C13.217 0 9.7545 3.73143 9.7545 8.30795C9.7545 12.6244 13.0749 19.2812 17.4935 19.2812ZM11.1498 8.30795C11.1498 4.49851 14.0051 1.40416 17.4935 1.40416C20.9819 1.40416 23.8372 4.49851 23.8372 8.30795C23.8372 10.3232 23.062 12.7805 21.8088 14.7307C20.5297 16.7329 18.9535 17.877 17.4935 17.877C16.0336 17.877 14.4573 16.7329 13.1783 14.7307C11.938 12.7805 11.1498 10.3232 11.1498 8.30795ZM32.739 23.7927C31.3436 22.4796 23.4238 20.1523 23.0878 20.0483L23.0232 20.0223L17.4935 24.0658L11.9767 20.0223L11.8992 20.0483C11.5633 20.1523 3.64339 22.4796 2.24804 23.7927C0.736411 25.2229 0.193776 29.9554 -2.29571e-05 32.6467C-0.0387826 33.2578 0.167936 33.8299 0.568452 34.2719C0.994809 34.727 1.60204 35 2.24804 35H32.7519C33.385 35 33.9922 34.727 34.4186 34.2719C34.8191 33.8299 35.0258 33.2578 34.9871 32.6467C34.7545 29.3574 34.1731 25.1449 32.739 23.7927ZM2.24804 33.5828C2.00256 33.5828 1.77 33.4918 1.60204 33.3098C1.45993 33.1538 1.39533 32.9588 1.40825 32.7507C1.75708 27.8232 2.59688 25.4049 3.21703 24.8198C3.82427 24.2348 7.46768 22.8436 11.7054 21.5695C16.8992 25.3789 17.0413 25.4699 17.4935 25.4699C18.1266 25.4699 18.1395 25.3399 23.2816 21.5695C27.5194 22.8436 31.1628 24.2348 31.7829 24.8198C32.3902 25.4049 33.2299 27.8232 33.5788 32.7507C33.5917 32.9588 33.5271 33.1538 33.385 33.3098C33.217 33.4918 32.9845 33.5828 32.7519 33.5828",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5833_30800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebUser);
export default __webpack_public_path__ + "static/media/WebUser.cb4a4e4beb7d234c994a42905ed2545c.svg";
export { ForwardRef as ReactComponent };